import { forwardRef } from 'react';

/**
 * Button — generic primary action button. Wraps the .lc-btn pattern.
 *
 * Props:
 *   variant: 'primary' (default) | 'ghost' | 'yellow' | 'ghost-light'
 *   size:    'sm' | 'md' (default) | 'lg'
 *   loading: boolean — disables and shows a spinner
 *   block:   stretch to full width
 *   as:      'button' (default) | 'a' — for href anchors
 */
const Button = forwardRef(function Button(
  { variant = 'primary', size = 'md', loading = false, disabled, block, as = 'button', className = '', children, ...rest },
  ref
) {
  const Tag = as;
  const sizeClass = size === 'lg' ? ' lg' : size === 'sm' ? ' sm' : '';
  return (
    <Tag
      ref={ref}
      disabled={Tag === 'button' ? (disabled || loading) : undefined}
      className={`lc-btn ${variant}${sizeClass} ${block ? 'w-full' : ''} ${className}`.trim()}
      style={{ justifyContent: block ? 'center' : undefined, opacity: (disabled || loading) ? 0.6 : 1, ...(rest.style || {}) }}
      {...rest}
    >
      {loading && (
        <span className="inline-block rounded-full border-2 border-white border-t-transparent animate-spin"
          style={{ width: 14, height: 14 }} />
      )}
      {children}
    </Tag>
  );
});

export default Button;
